var IRenderable = (function () {
    function IRenderable() {
    }
    return IRenderable;
}());
export { IRenderable };
